import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import AIComp from './AIComp'

function AiAssistant() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <AdmissionTopNotice/>
              <AIComp/>
            </div>
        </div> 
    </div>
  )
}

export default AiAssistant